module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_purete-546ba62dae715f75150f63f25fd0f3ce.svg";